import React from "react";
import "./PageTitle.css";

export default function PageTitle({ title, subtitle }: { title?: string, subtitle?: string; }) {
  return (
    <div className="d-flex flex-column gap-0" style={{ fontSize: "11px" }}>
      {
        title && (
          <strong className="font-code p-0 m-0 text-nowrap text-uppercase page-title" style={{ color: "var(--gray-400)", letterSpacing: "0.03em" }}>
            {title}
          </strong>
        )
      }
      {
        subtitle && (
          <span style={{ color: "var(--gray-900)" }}>
            {subtitle}
          </span>
        )
      }
    </div >
  )
}